const AGILE = 'agile'; // 雅居乐
const CHANG_YOU = 'changyou'; // 广东畅由
const SC_CHANG_YOU = 'scmobile'; // 四川畅由
const ZJ_CHANG_YOU = 'zjmobile'; // 浙江畅由
const BJ_CHANG_YOU = 'bjmobile'; // 北京畅由

const CHANNEL = {
    CHANG_YOU: CHANG_YOU,
    AGILE: AGILE,
    SC_CHANG_YOU: SC_CHANG_YOU, // 四川移动，畅由的分支
    ZJ_CHANG_YOU: ZJ_CHANG_YOU,
    BJ_CHANG_YOU: BJ_CHANG_YOU,
};

export const CHANNEL_MAP = {
    [CHANG_YOU]: {
        name: CHANG_YOU,
    },
    [AGILE]: {
        name: AGILE,
    },
    [SC_CHANG_YOU]: {
        name: SC_CHANG_YOU,
        parent: CHANG_YOU,
    },
    [ZJ_CHANG_YOU]: {
        name: ZJ_CHANG_YOU,
        parent: CHANG_YOU,
    },
    [BJ_CHANG_YOU]: {
        name: BJ_CHANG_YOU,
        parent: CHANG_YOU,
    },
};

export default CHANNEL;
